export const updateEvidence = (oldData, updated) => {
    // Assume updated is an object matching this pattern:
    // {
    //   attestationRecordId: number,
    //   subcomponentId: number,
    //   overallRating: number,
    //   overallCompliance: number,
    //   ratingId?: number,
    //   statusId?: number,
    //   comment?: string,
    //   capturedByUser?: boolean,
    //   evidence: { evidenceId: number, fileName: string, fileType: string, fileUrl: string }
    // }

    // Return oldData if it's not properly structured or if updated is missing
    if (!oldData || !updated || !updated.subcomponentId) {
        return oldData;
    }

    // Handle the nested json structure if present
    const dataToUpdate = oldData?.json ? oldData.json : oldData;

    if (!dataToUpdate || !Array.isArray(dataToUpdate.components)) {
        return oldData;
    }

    // Create a deep copy of the data structure
    const updatedData = {
        ...dataToUpdate,
        // Update overall ratings if provided
        ...(updated.overallRating !== undefined && { overallRating: updated.overallRating }),
        ...(updated.overallCompliance !== undefined && {
            overallCompliance: updated.overallCompliance,
        }),
        components: dataToUpdate.components.map((component) => ({
            ...component,
            subcomponents: component.subcomponents.map((subcomponent) => {
                // Find the matching subcomponent by subcomponentId
                if (subcomponent.subcomponentId === updated.subcomponentId) {
                    return {
                        ...subcomponent,
                        // Update fields if they exist in the updated object
                        ...(updated.ratingId !== undefined && { ratingId: updated.ratingId }),
                        ...(updated.statusId !== undefined && { statusId: updated.statusId }),
                        ...(updated.comment !== undefined && { comment: updated.comment }),
                        ...(updated.attestationRecordId !== undefined && {
                            attestationRecordId: updated.attestationRecordId,
                        }),
                        ...(updated.capturedByUser !== undefined && {
                            capturedByUser: updated.capturedByUser,
                        }),
                        // Update evidence if provided
                        ...(updated.evidence && {
                            evidence: {
                                ...subcomponent.evidence,
                                ...updated.evidence,
                            },
                        }),
                    };
                }
                return subcomponent;
            }),
        })),
    };

    // Return in the same structure as received
    return oldData?.json ? { ...oldData, json: updatedData } : updatedData;
};
